export default function FaultsViewDeleteController(
  $scope,
  $uibModalInstance,
  configurationId,
  configurationName,
  $state,
  faultsService,
  gettextCatalog
) {
  'ngInject';

  var vm = this;

  vm.configurationName = configurationName;
  vm.loading = false;
  vm.errorText = '';

  vm.ok = ok;
  vm.cancel = cancel;

  function ok() {
    vm.loading = true;
    vm.errorText = null;
    faultsService
      .deleteFaultConfig(configurationId)
      .then(function(response) {
        $uibModalInstance.close();
        $state.go('alerts.faults.list');
      })
      .catch(function(error) {
        vm.errorText = gettextCatalog.getString('An error occurred while deleting the configuration');
      })
      .finally(function() {
        vm.loading = false;
      });
  }

  function cancel() {
    $uibModalInstance.close('cancel');
  }

  $scope.$on('$locationChangeStart', function(event, next, current) {
    cancel();
  });
}
